module.exports = __webpack_public_path__ + "img/gecao.7ca65f25.png";